module.exports = __webpack_public_path__ + "img/garden_full.2ef5ff9c.jpg";